import { Requirements } from "./requirements.component";
import { Requirement } from "./requirement.component";
import { EditRequirement } from "./requirement.edit.component";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { requirementsState, requirementState, newRequirementState, editRequirementState } from "./requirements.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let REQUIREMENT_STATES = [requirementsState, requirementState, newRequirementState, editRequirementState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: REQUIREMENT_STATES })
    ],
    declarations: [Requirements, Requirement, EditRequirement],
    entryComponents: [ConfirmDialog]
})
export class RequirementsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/requirements/requirements.module.ts